import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { CheckpointModel } from '../checkpoint.model';
import { IFiChecklistAnswerModel } from '@fi-shared/checklist';
import { UserService } from '@fi-app/user/user.service';
import { BusinessUnitService } from '@fi-app/business-unit/business-unit.service';

@Component({
    selector: 'fi-checklist-checkpoint-view-additional-info',
    templateUrl: './checkpoint-view-additional-info.component.html',
    standalone: false,
})
export class FiChecklistCheckpointViewAdditionalInfoComponent implements OnChanges {
    @Input() checkpoint: CheckpointModel;
    @Input() checkpointAnswer: IFiChecklistAnswerModel;
    @Input() checklistViewer;
    @Input() businessUnitId?: number;
    @Input() businessUnitName?: string;
    @Input() showBusinessUnit: boolean = false;

    checkpointEditData?: {
        ChangedByUserName: string;
        ChangedOn: string;
        ChangedByUserId: number;
    };

    constructor(
        private cdr: ChangeDetectorRef,
        private userService: UserService,
        private businessUnitService: BusinessUnitService,
    ) {}

    ngOnChanges() {
        this.updateEditData();
    }

    updateEditData() {
        if (this.checkpointAnswer && this.checkpointAnswer.CheckPointId && this.checkpointAnswer.ChangedByUserId) {
            this.checkpointEditData = {
                ChangedByUserName: this.checkpointAnswer.ChangedByUserName,
                ChangedOn: this.checkpointAnswer.ChangedOn,
                ChangedByUserId: this.checkpointAnswer.ChangedByUserId,
            };
        }

        if (
            this.checkpoint.CheckPointSetting &&
            this.checkpoint.CheckPointSetting.ChangedOn &&
            (!this.checkpointEditData ||
                new Date(this.checkpoint.CheckPointSetting.ChangedOn) > new Date(this.checkpointEditData.ChangedOn))
        ) {
            this.checkpointEditData = {
                ChangedByUserName: this.checkpoint.CheckPointSetting.ChangedByUserName,
                ChangedOn: this.checkpoint.CheckPointSetting.ChangedOn,
                ChangedByUserId: this.checkpoint.CheckPointSetting.ChangedByUserId,
            };
        }

        this.cdr.detectChanges();
    }

    openUserProfileDialog(userId: number) {
        this.userService.openUserViewDialog(userId);
    }

    openBusinessUnitViewDialog(businessUnitId: number) {
        this.businessUnitService.openBusinessUnitViewDialog(businessUnitId);
    }
}
